import React from "react"

export default function IndustryHeader(props) {
  return (
    <section className="industryHeader">
      <div className="industryHeaderContent">
        <div className="contentTitle">
          <div className="industryIcon">{props.headerIcon}</div>
          <h1 className="industryName">{props.headerTitle}</h1>
        </div>
        <p className="industrySubtitle">{props.headerSubtitle}</p>
      </div>
    </section>
  )
}
